import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Gender, KnownGender, KnownStaffPosition, StaffPosition } from '../api/domain';

export interface DocumentFile {
  id: number,
  name: string,
  contentType: string,
  content: string,
  creationDate: string,
  userId: number
}

@Injectable()
export default class Helpers {
  static equalDates(fecha1: Date, fecha2: Date): boolean {
    return ((fecha1.getFullYear() === fecha2.getFullYear()) && (fecha1.getMonth() === fecha2.getMonth()) && (fecha1.getDate() === fecha2.getDate()));
  }

  static downloadFile(doc: DocumentFile) {
    let fileUrl = this.getBlobFileUrl(doc);
    fetch(fileUrl)
      .then(response => response.blob())
      .then(blob => {
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, doc.name);
        }
        else {
          let aux = document.createElement('a');
          aux.href = URL.createObjectURL(blob);
          aux.download = doc.name;
          var event = new MouseEvent("click");
          aux.dispatchEvent(event);
        }

        //**********To open in browser**********//
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        //if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //  window.navigator.msSaveOrOpenBlob(blob);
        //  return;
        //}
        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        //const downloadURL = URL.createObjectURL(blob);
        //window.open(downloadURL);

      });
  }

  static getBlobFileUrl(doc: DocumentFile): string {
    if (!doc || !doc.contentType || !doc.content || doc.content === 'null') return '';
    return "data:" + doc.contentType + ";base64," + doc.content;
  }

  static getIndicatorIcon(indicator: string): string {
    if (indicator == "negative" || indicator == "-")
      return "arrow-down";
    else if (indicator == "positive" || indicator == "+")
      return "arrow-up";
    else if (indicator == "equal" || indicator == "=")
      return "minus";
    return "";
  }

  static getIndicatorIconStatus(indicator: string): string {
    if (indicator == "negative" || indicator == "-")
      return "danger";
    else if (indicator == "positive" || indicator == "+")
      return "success";
    else if (indicator == "equal" || indicator == "=")
      return "primary";
    return "";
  }

  static isIndicatorIconAvailable(indicator: string): boolean {
    if (!indicator || indicator == "") return false;
    return ["+", "-", "=", "positive", "negative", "equal"].includes(indicator);
  }

  static getDateString(date: any): string {
    return date ? moment(date, "YYYY-MM-DD").format('DD/MM/YYYY') : '-';
  }

  static getAvatarForGender(gender: Gender, staffPosition: StaffPosition, isReport: boolean = false): string {
    if (!gender)
      return "assets/images/profile_man_report.png";
    if (isReport) {
      if (gender.description === KnownGender.FEMENINO)
        return `assets/images/profile_woman_report.png`;
      else if (gender.description === KnownGender.MASCULINO)
        return `assets/images/profile_man_report.png`;
    }
    else {
      if (gender.description === KnownGender.FEMENINO) {
        if (!staffPosition)
          return `assets/images/person_woman.jpeg`;
        if (staffPosition.description == KnownStaffPosition.EVALUADOR || staffPosition.id == 2)
          return `assets/images/avatar_mujer_evaluador.png`;
        else if (staffPosition.description == KnownStaffPosition.NUTRICIONISTA || staffPosition.id == 1)
          return `assets/images/avatar_mujer_nutricionista.png`;
        else if (staffPosition.description == KnownStaffPosition.SECRETARIA || staffPosition.id == 3)
          return `assets/images/avatar_mujer_secretaria.png`;
        else
          return `assets/images/person_woman.jpeg`;
      }
      else if (gender.description === KnownGender.MASCULINO) {
        if (!staffPosition)
          return `assets/images/person_man.jpeg`;
        else if (staffPosition.description == KnownStaffPosition.EVALUADOR || staffPosition.id == 2)
          return `assets/images/avatar_hombre_evaluador.png`;
        else if (staffPosition.description == KnownStaffPosition.NUTRICIONISTA || staffPosition.id == 1)
          return `assets/images/avatar_hombre_nutricionista.png`;
        else if (staffPosition.description == KnownStaffPosition.SECRETARIA || staffPosition.id == 3)
          return `assets/images/avatar_hombre_secretario.png`;
        else
          return `assets/images/person_man.jpeg`;
      }
      else
        return "assets/images/profile_man_report.png";
    }
  }

  static getPatientFullName(patient: any): string {
    if (!patient || !patient.name) return "-";
    return `${patient.name}${patient.surname ? ` ${patient.surname}` : ""}`;
  }

  static getPatientAge(patient: any): string {
    if (!patient || !patient.birthday) return "Edad desconocida";
    let birthday = moment(patient.birthday, "YYYY-MM-DD");
    let diff = moment().diff(birthday, 'years');
    return `${diff} años`;
  }

  static async getBase64FromUrl(url: string): Promise<string | ArrayBuffer> {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
        let base64data = reader.result;
        resolve(base64data);
      }
    });
  }
}

export enum ReportMenuNames {
  REPORTES_2C = "Reportes FA 2C",
  REPORTES_5C = "Reportes FA 5C"
}
